// extracted by mini-css-extract-plugin
export default {"datosContainer":"general-data-form_styles_component_datosContainer__HG2fM","apellidosContainer":"general-data-form_styles_component_apellidosContainer__mDQ5L"};